(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9133],{

/***/ 22284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12963);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);


var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs;
    var schemaJson = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: []
    };
    var formatJSON = function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@id": "".concat(breadcrumb.url),
                name: "".concat(breadcrumb.content)
            }
        };
    };
    var createBreadcrumbSchema = function() {
        schemaJson.itemListElement = breadcrumbs.map(function(breadcrumb, index) {
            return formatJSON(breadcrumb, index);
        }) || [];
        return schemaJson;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: breadcrumbs.map(function(param, index) {
                    var content = param.content, url = param.url;
                    return index + 1 !== breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "body2",
                        children: content
                    }, content) || index + 1 === breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        role: "heading",
                        variant: "body2",
                        children: content
                    }, content);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                "data-testid": "breadcrumbListSchema",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createBreadcrumbSchema())
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 6551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70872);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6964);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);




var OffsetPagination = function(param) {
    var pagination = param.pagination, onPageClick = param.onPageClick, segmentId = param.segmentId, pageSelected = param.pageSelected;
    var hasPages = pagination.numberOfPages > 1;
    var hasResults = pagination.numberOfPages > 0;
    var isFirstPage = pageSelected === 1;
    var isLastPage = pageSelected === pagination.numberOfPages;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var handleChangePage = function(event, newPage) {
        event.preventDefault();
        onPageClick(newPage);
        // only show "page" for pages > 1; "/senior-care-page1" should just be "/senior-care"
        var url = newPage === 1 ? segmentId : "".concat(segmentId, "-page").concat(newPage.toString());
        router.push(url, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: [
            hasPages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                mt: 3,
                mb: 2.25,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    count: pagination.numberOfPages,
                    onChange: handleChangePage,
                    page: pageSelected,
                    renderItem: function(item) {
                        var isNextButton = item.type === "next";
                        var isPrevButton = item.type === "previous";
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            component: isNextButton && isLastPage || isPrevButton && isFirstPage ? "div" : "a",
                            href: isNextButton && isLastPage || isPrevButton && isFirstPage ? undefined : "".concat(segmentId).concat(item.page === 1 || item.page === 0 ? "" : "-page".concat(item.page)),
                            role: "button"
                        }, item));
                    },
                    sx: {
                        "& .MuiPaginationItem-page": {
                            minWidth: "24px",
                            height: "24px"
                        }
                    }
                })
            }),
            hasResults && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                role: "heading",
                variant: "body3",
                color: "primary",
                mt: !hasPages ? 3 : undefined,
                mb: 3,
                children: [
                    "Showing ",
                    pagination.startIndex + 1,
                    " - ",
                    pagination.endIndex,
                    " of",
                    " ",
                    pagination.totalNumberOfResults
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OffsetPagination);


/***/ }),

/***/ 79274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ColumnarLinkedList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23795);
/* harmony import */ var _utils_columnarLinkedList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12806);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19147);




var ColumnarLinkedList = function(param) {
    var items = param.items, _desktopItemsPerColumn = param.desktopItemsPerColumn, desktopItemsPerColumn = _desktopItemsPerColumn === void 0 ? 11 : _desktopItemsPerColumn, _tabletItemsPerColumn = param.tabletItemsPerColumn, tabletItemsPerColumn = _tabletItemsPerColumn === void 0 ? 13 : _tabletItemsPerColumn;
    var ref = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_1__/* .useResponsive */ .F)(), isMediumViewport = ref.isMediumViewport, isLargeViewport = ref.isLargeViewport;
    var itemListLength = items.length;
    var numItemsPerColumn = function() {
        if (isLargeViewport) return desktopItemsPerColumn;
        if (isMediumViewport) return tabletItemsPerColumn;
        if (itemListLength / 2 <= 22) {
            return itemListLength;
        }
        return Math.ceil(itemListLength / 2);
    }();
    var itemColumns = (0,_utils_columnarLinkedList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(items, numItemsPerColumn);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        container: true,
        columnSpacing: {
            sm: 6,
            md: 8
        },
        children: itemColumns.map(function(itemColumn, columnIndex) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                sx: {
                    paddingRight: {
                        xs: 3,
                        sm: 3,
                        md: 0
                    },
                    listStyle: "none",
                    minWidth: {
                        md: "250px"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    component: "ul",
                    m: 0,
                    p: 0,
                    sx: {
                        listStyle: "none"
                    },
                    children: itemColumn.map(function(item, itemIndex) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            component: "li",
                            mb: 2,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                variant: "link2",
                                href: item.link,
                                sx: {
                                    textDecoration: "underline",
                                    color: "text.primary"
                                },
                                children: item.name
                            })
                        }, "item-".concat(columnIndex + 1, "-").concat(itemIndex + 1));
                    })
                })
            }, "col-".concat(columnIndex + 1));
        })
    });
};


/***/ }),

/***/ 30080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ FAQList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82280);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38895);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22797);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56721);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81956);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84899);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);







var FAQList = function(param) {
    var faqs = param.faqs;
    var isEmbraceTheme = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isEmbraceTheme;
    var ref = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var createFaqSchema = function(faqList) {
        var mainEntity = faqList.map(function(faq) {
            return {
                "@type": "Question",
                name: "".concat(faq.question),
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "".concat(faq.answer)
                }
            };
        });
        return {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: mainEntity
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                sx: {
                    mb: 2,
                    mt: 0
                }
            }),
            faqs.map(function(faq, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            sx: {
                                boxShadow: "none"
                            },
                            disableGutters: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        color: "icon.primary"
                                    }),
                                    "aria-controls": "panel-".concat(index, "-content"),
                                    id: "panel-".concat(index, "-header"),
                                    sx: {
                                        px: 0,
                                        "& .MuiAccordionSummary-content": {
                                            minHeight: "56px",
                                            display: "flex",
                                            alignItems: "center"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        component: "h4",
                                        variant: isEmbraceTheme || isSmallViewport || isMediumViewport ? "h3" : "h2",
                                        mr: 3,
                                        children: faq.question
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    sx: {
                                        p: 0
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        variant: "body2",
                                        sx: {
                                            "& a": {
                                                color: "text.link",
                                                textDecoration: "underline"
                                            }
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: sanitize_html__WEBPACK_IMPORTED_MODULE_11___default()(he__WEBPACK_IMPORTED_MODULE_1___default().decode(faq.answer).replace(/\n/g, "<br>"))
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            sx: {
                                my: 2
                            }
                        })
                    ]
                }, "faq-".concat(index + 1));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createFaqSchema(faqs))
                }
            })
        ]
    });
};


/***/ }),

/***/ 33424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ReadMore; }
/* harmony export */ });
/* unused harmony export splitValueIntoParts */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23795);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_6__);
/* eslint-disable jsx-a11y/anchor-is-valid */ 






var SPACE_CHAR = " ";
var WHITE_SPACE_REGEXP = /\s*$/;
var DOUBLE_QUOTES = '"';
var splitValueIntoParts = function(value, charLimit) {
    if (!value) {
        return {
            teaser: value
        };
    }
    var remainingWords = [];
    var teaserWords = value.split(SPACE_CHAR);
    while(teaserWords.join(SPACE_CHAR).length > charLimit){
        remainingWords.unshift(teaserWords.pop());
    }
    return {
        teaser: teaserWords.join(SPACE_CHAR),
        remaining: remainingWords.join(SPACE_CHAR)
    };
};
var ReadMore = function(_param) {
    var value = _param.value, _charLimit = _param.charLimit, charLimit = _charLimit === void 0 ? 500 : _charLimit, _ellipses = _param.ellipses, ellipses = _ellipses === void 0 ? "..." : _ellipses, _displayShowLessButton = _param.displayShowLessButton, displayShowLessButton = _displayShowLessButton === void 0 ? true : _displayShowLessButton, _showDoubleQuotes = _param.showDoubleQuotes, showDoubleQuotes = _showDoubleQuotes === void 0 ? false : _showDoubleQuotes, _onShowMoreClick = _param.onShowMoreClick, onShowMoreClick = _onShowMoreClick === void 0 ? function() {} : _onShowMoreClick, _onShowLessClick = _param.onShowLessClick, onShowLessClick = _onShowLessClick === void 0 ? function() {} : _onShowLessClick, _showMoreLabel = _param.showMoreLabel, showMoreLabel = _showMoreLabel === void 0 ? "more" : _showMoreLabel, _showLessLabel = _param.showLessLabel, showLessLabel = _showLessLabel === void 0 ? "less" : _showLessLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "charLimit",
        "ellipses",
        "displayShowLessButton",
        "showDoubleQuotes",
        "onShowMoreClick",
        "onShowLessClick",
        "showMoreLabel",
        "showLessLabel"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setIsExpanded(!isExpanded);
        if (isExpanded) {
            onShowLessClick();
        } else {
            onShowMoreClick();
        }
    }, [
        isExpanded,
        onShowMoreClick,
        onShowLessClick
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return splitValueIntoParts(value, charLimit);
    }, [
        value,
        charLimit
    ]), teaser = ref1.teaser, remaining = ref1.remaining;
    var canBeToggled = value.length > charLimit;
    var splitContent = !isExpanded ? "".concat(teaser.replace(WHITE_SPACE_REGEXP, "")) : "".concat(teaser, " ").concat(remaining);
    var content = canBeToggled ? splitContent : value;
    var toggleLabel = isExpanded ? "".concat(showLessLabel) : "".concat(showMoreLabel);
    var hideToggle = canBeToggled && (!isExpanded || displayShowLessButton);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: [
            showDoubleQuotes && "".concat(DOUBLE_QUOTES),
            content,
            showDoubleQuotes && !hideToggle && "".concat(DOUBLE_QUOTES),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("noscript", {
                dangerouslySetInnerHTML: {
                    __html: remaining ? sanitize_html__WEBPACK_IMPORTED_MODULE_6___default()(remaining) : ""
                }
            }),
            hideToggle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    isExpanded && showDoubleQuotes && "".concat(DOUBLE_QUOTES),
                    isExpanded && "".concat(SPACE_CHAR),
                    !isExpanded && "".concat(ellipses).concat(SPACE_CHAR),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        sx: {
                            font: "inherit",
                            verticalAlign: "inherit",
                            textDecoration: "underline"
                        },
                        component: "button",
                        onClick: handleToggle,
                        children: toggleLabel
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 38071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ BreadcrumbsSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46574);
/* harmony import */ var _components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22284);
/* harmony import */ var _context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32826);




var BreadcrumbsSection = function() {
    var pageData = (0,_context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_2__/* .useSearchDirectoryData */ .Q)();
    var breadcrumbs = pageData.seoSegmentationBreadcrumbs.__typename === "SEOSegmentationBreadcrumbsSuccess" ? pageData.seoSegmentationBreadcrumbs.breadcrumbs : null;
    if (!breadcrumbs) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            backgroundColor: "background.secondary",
            pb: {
                xs: 6,
                sm: 8
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            maxWidth: "lg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                breadcrumbs: breadcrumbs
            })
        })
    });
};


/***/ }),

/***/ 96607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32826);
/* harmony import */ var _components_common_FAQList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30080);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);





var FAQSection = function() {
    var ref;
    var pageData = (0,_context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_1__/* .useSearchDirectoryData */ .Q)();
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)().isSmallViewport;
    var ref1;
    var segmentationFAQs = (ref1 = pageData === null || pageData === void 0 ? void 0 : pageData.getSEOSegmentationFAQs) !== null && ref1 !== void 0 ? ref1 : null;
    var faqList = segmentationFAQs === null || segmentationFAQs === void 0 ? void 0 : (ref = segmentationFAQs.faqList) === null || ref === void 0 ? void 0 : ref.filter(function(faq) {
        return faq !== null;
    });
    if (!segmentationFAQs || !faqList) return null;
    var title = segmentationFAQs.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        maxWidth: "lg",
        sx: {
            my: {
                xs: 6,
                md: 10
            },
            px: {
                xl: 0
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            container: true,
            item: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    item: true,
                    md: 5,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        component: "h2",
                        variant: isSmallViewport ? "h1" : "display3",
                        sx: {
                            mt: 0,
                            maxWidth: {
                                md: "90%",
                                lg: "75%"
                            },
                            mb: {
                                xs: 4,
                                sm: 3,
                                md: 0
                            }
                        },
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    item: true,
                    md: 7,
                    children: faqList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_FAQList__WEBPACK_IMPORTED_MODULE_2__/* .FAQList */ .V, {
                        faqs: faqList
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 53166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ InternalLinkingSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24Chevron.js
var Icon24Chevron = __webpack_require__(84899);
// EXTERNAL MODULE: ./src/components/common/ColumnarLinkedList.tsx
var ColumnarLinkedList = __webpack_require__(79274);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
// EXTERNAL MODULE: ./src/context/searchDirectory/SearchDirectoryDataContext.tsx
var SearchDirectoryDataContext = __webpack_require__(32826);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash-es/cloneDeepWith.js + 31 modules
var cloneDeepWith = __webpack_require__(43539);
// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/hooks/useInternalLinking.tsx






var useInternalLinking = function(internalLinkingSections) {
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), pageType = ref.pageType, segmentNameSingular = ref.segmentNameSingular, segmentNamePlural = ref.segmentNamePlural;
    var getSectionTitle = function(sectionId) {
        if (sectionId === globalTypes/* InternalLinkSectionId.RELATED_SERVICES */.$z.RELATED_SERVICES) {
            return "Sub-categories";
        }
        if (sectionId === globalTypes/* InternalLinkSectionId.TOP_CITIES */.$z.TOP_CITIES) {
            if (pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
                return "".concat(segmentNameSingular, " in Top Cities");
            }
            return "".concat(segmentNamePlural, " in Nearby Cities");
        }
        if (sectionId === globalTypes/* InternalLinkSectionId.RESOURCES */.$z.RESOURCES) {
            return "More Services";
        }
        return null;
    };
    var filterSections = function(seoLinkSections) {
        return seoLinkSections.reduce(function(result, section) {
            // Filter out ARTICLES and JOBS section
            if (section.id === globalTypes/* InternalLinkSectionId.ARTICLES */.$z.ARTICLES || section.id === globalTypes/* InternalLinkSectionId.JOBS */.$z.JOBS) {
                return result;
            }
            // Find RESOURCES section
            if (section.id === globalTypes/* InternalLinkSectionId.RESOURCES */.$z.RESOURCES) {
                var jobSection = seoLinkSections.find(function(currentSection) {
                    return currentSection.id === globalTypes/* InternalLinkSectionId.JOBS */.$z.JOBS;
                });
                // If JOBS section exists, combine its linkList with RESOURCES section's linkList
                if (jobSection) {
                    var combinedSection = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
                        linkList: section.linkList.concat(jobSection.linkList)
                    });
                    return (0,_to_consumable_array/* default */.Z)(result).concat([
                        combinedSection
                    ]);
                }
            }
            return (0,_to_consumable_array/* default */.Z)(result).concat([
                section
            ]);
        }, []);
    };
    var sortSections = function(seoLinkSections) {
        var nationalOrLocalPageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        var nationalPageTabOrder = Object.freeze({
            RELATED_SERVICES: 1,
            TOP_CITIES: 2,
            RESOURCES: 3,
            NULL_ID: 4
        });
        var localPageTabOrder = Object.freeze({
            TOP_CITIES: 1,
            RELATED_SERVICES: 2,
            RESOURCES: 3,
            NULL_ID: 4
        });
        return (0,cloneDeepWith/* default */.Z)(seoLinkSections).sort(function(linkSectionA, linkSectionB) {
            var sectionAId = linkSectionA.id ? linkSectionA.id.toString() : "NULL_ID";
            var sectionBId = linkSectionB.id ? linkSectionB.id.toString() : "NULL_ID";
            if (nationalOrLocalPageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
                return nationalPageTabOrder[sectionAId] - nationalPageTabOrder[sectionBId];
            }
            return localPageTabOrder[sectionAId] - localPageTabOrder[sectionBId];
        });
    };
    if (!internalLinkingSections) return null;
    var filteredSections = filterSections(internalLinkingSections);
    var ref1;
    return sortSections(filteredSections, pageType).map(function(section) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
            title: (ref1 = getSectionTitle(section.id)) !== null && ref1 !== void 0 ? ref1 : section.title
        });
    });
};

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/InternalLinkingSection.tsx









var InternalLinkingSection = function() {
    var ref;
    var pageData = (0,SearchDirectoryDataContext/* useSearchDirectoryData */.Q)();
    var internalLinkingHeadline = pageData.seoSegmentationDetails.internalLinkingHeadline;
    var headline = internalLinkingHeadline !== null && internalLinkingHeadline !== "null" && internalLinkingHeadline !== "" ? internalLinkingHeadline : "Additional Services";
    var _getSEOSegmentationLinkSections;
    var internalLinkingSection = (_getSEOSegmentationLinkSections = pageData.getSEOSegmentationLinkSections) !== null && _getSEOSegmentationLinkSections !== void 0 ? _getSEOSegmentationLinkSections : null;
    var maplinkListToColumnarLinkList = function(linkList) {
        return linkList.map(function(param) {
            var content = param.content, url = param.url;
            return {
                name: content,
                link: url
            };
        });
    };
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var sectionList = (ref = useInternalLinking(internalLinkingSection)) === null || ref === void 0 ? void 0 : ref.map(function(section) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
            linkList: maplinkListToColumnarLinkList(section.linkList)
        });
    });
    if (!internalLinkingSection || !sectionList) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            backgroundColor: "background.secondary",
            pt: {
                xs: 6,
                sm: 8
            },
            pb: {
                xs: 4,
                sm: 6
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "h3",
                    variant: isSmallViewport ? "h1" : "display3",
                    sx: {
                        mb: {
                            xs: 4,
                            sm: 6
                        },
                        mt: 0
                    },
                    children: headline
                }),
                sectionList.map(function(param) {
                    var title = param.title, linkList = param.linkList;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                        sx: {
                            boxShadow: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                sx: {
                                    width: {
                                        sm: "fit-content"
                                    },
                                    p: 0,
                                    mb: 3,
                                    "& .MuiAccordionSummary-content": {
                                        mr: 2
                                    }
                                },
                                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24Chevron/* default */.Z, {}),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h3",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                sx: {
                                    p: 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColumnarLinkedList/* ColumnarLinkedList */.X, {
                                    items: linkList
                                })
                            })
                        ]
                    }, title);
                })
            ]
        })
    });
};


/***/ }),

/***/ 91195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ NoSearchResults; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58939);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54222);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);








var NoSearchResults = function() {
    var ref = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)(), seoPageId = ref.seoPageId, serviceIdForMember = ref.serviceIdForMember, deviceChar = ref.deviceChar, pageType = ref.pageType;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var pageProperties = {
            screen_name: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenName.SEGMENTATION */ .CG.SEGMENTATION,
            screen_template: _constants__WEBPACK_IMPORTED_MODULE_3__/* .ScreenTemplate.SEGMENTATION */ .Yj.SEGMENTATION,
            seo_page_id: Number(seoPageId),
            service_id_for_member: serviceIdForMember,
            slots: _constants__WEBPACK_IMPORTED_MODULE_3__/* .TealiumSlot.VISITOR */ .vm.VISITOR
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .setPagePropertiesFromData */ .UP)(pageProperties);
            (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .setDeviceDataFromHeaders */ .xF)(deviceChar);
        }
        var errorViewedData = {
            seo_page_type: (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase()),
            error_description: "SEO no results",
            service_id_for_member: serviceIdForMember
        };
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.errorViewed */ .Sj.errorViewed, errorViewedData);
    }, [
        deviceChar,
        pageType,
        seoPageId,
        serviceIdForMember
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        px: {
            xs: 3,
            sm: 0
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "background.default",
                borderRadius: {
                    xs: 6,
                    sm: 8
                },
                px: 4,
                py: 6
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    size: 128,
                    sx: {
                        mb: 3
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    variant: "h3",
                    textAlign: "center",
                    children: "No matches within your search"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    variant: "body2",
                    textAlign: "center",
                    children: "Try changing your filters to see more results."
                })
            ]
        })
    });
};


/***/ }),

/***/ 53653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ SearchResults; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80822);



var SearchResults = function(param) {
    var items = param.items, renderItem = param.renderItem;
    var content = [];
    items.forEach(function(item, index) {
        content.push(renderItem(item, index));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: content
    });
};


/***/ }),

/***/ 34664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ZipCodeConversion; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53340);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87109);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69417);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59242);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79967);
/* harmony import */ var _utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7360);
/* harmony import */ var _context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32826);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);











var ZipCodeConversion = function(param) {
    var showZipCodeInputField = param.showZipCodeInputField, _isDirectoryFirstExperience = param.isDirectoryFirstExperience, isDirectoryFirstExperience = _isDirectoryFirstExperience === void 0 ? false : _isDirectoryFirstExperience, ctaText = param.ctaText, handleCtaBtn = param.handleCtaBtn;
    var ref = (0,_context_searchDirectory_SearchDirectoryDataContext__WEBPACK_IMPORTED_MODULE_3__/* .useSearchDirectoryData */ .Q)(), pageType = ref.seoSegmentationDetails.pageType;
    var ref1 = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)(), enrollmentURL = ref1.enrollmentURL, userGeoInfo = ref1.userGeoInfo;
    var zipInputRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var prefillZipCode = function() {
        if (pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_2__/* .SEOSegmentationPageType.NATIONAL */ .a6.NATIONAL) {
            return (0,_utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_5__/* .getZipcodeFromGeoInfo */ .Z)(userGeoInfo);
        }
        return "";
    };
    var zipCodeRegex = /^\d{0,5}$/;
    var prefilledZipCode = prefillZipCode();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        zipCode: prefilledZipCode
    }), zip = ref2[0], setZip = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (zipInputRef.current) {
            zipInputRef.current.setSelectionRange(zipInputRef.current.value.length, zipInputRef.current.value.length);
            zipInputRef.current.focus();
        }
    }, [
        zip
    ]);
    var enrollmentLink = function() {
        if (zip.zipCode && zip.zipCode.length === 5) {
            return "".concat(enrollmentURL, "&zipcode=").concat(zip.zipCode);
        }
        if (isDirectoryFirstExperience) {
            return "".concat(enrollmentURL, "&zipcode=").concat((0,_utils_getZipcodeFromGeoInfo__WEBPACK_IMPORTED_MODULE_5__/* .getZipcodeFromGeoInfo */ .Z)(userGeoInfo));
        }
        return "".concat(enrollmentURL);
    }();
    var onZipCodeChange = function(e) {
        var zipCodeVal = e.target.value;
        if (!zipCodeRegex.test(zipCodeVal)) {
            return;
        }
        setZip(function(prevValues) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, prevValues), {
                zipCode: zipCodeVal
            });
        });
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") {
            globalThis.location.href = "".concat(enrollmentLink);
            handleCtaBtn();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            mb: 4
        },
        children: [
            showZipCodeInputField && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                id: "zipCode",
                name: "zipCode",
                inputRef: zipInputRef,
                onKeyUp: handleKeyUp,
                placeholder: "ZIP code",
                value: zip.zipCode,
                onChange: onZipCodeChange,
                InputProps: {
                    startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        position: "start",
                        sx: {
                            ml: 2
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                    })
                },
                sx: {
                    mb: 3,
                    width: {
                        xs: "100%",
                        sm: "329px",
                        md: "369px"
                    },
                    "& .MuiInputAdornment-root": {
                        ml: 0
                    },
                    "& .MuiInputBase-root": {
                        minHeight: "62px"
                    },
                    "& input[type=text]": {
                        color: "text.secondary",
                        fontSize: "body2.fontSize",
                        lineHeight: "body2.lineHeight",
                        pb: 0
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                color: "primary",
                href: enrollmentLink,
                onClick: handleCtaBtn,
                size: "large",
                variant: "contained",
                rel: "nofollow",
                sx: {
                    width: {
                        xs: "100%",
                        md: "369px"
                    }
                },
                children: ctaText
            })
        ]
    });
};


/***/ }),

/***/ 99661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getHeroImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _helpers_generateURLWithParams__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8018);



/**
 * @description Returns the hero image URL based on the serviceId and seoSegmentId.
 * @param {Object} params - The parameters object.
 * @param {string} params.seoSegmentId - The seoSegmentId such as '/babysitters' or '/babysitters/austin-tx'.
 * @param {string} params.serviceId - The serviceId such as 'HOUSEKEEP'.
 * @returns {string|null} The hero image URL or null if not found.
 */ var getHeroImage = function(param) {
    var seoSegmentId = param.seoSegmentId, serviceId = param.serviceId;
    // separate the segment from the rest of the url (e.g. /child-care/boston-ma -> /child-care)
    var segment = "/".concat(seoSegmentId.split("/")[1]);
    var imQueryParams = {
        im: ""
    };
    var _obj;
    var heroImageVerticalMap = Object.freeze((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.CAREGIGSX */ .Xs.CAREGIGSX, "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/heroImages/personal-assistant-hero-collage.png"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.CHILDCARE */ .Xs.CHILDCARE, "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/heroImages/child-care-hero-collage.png"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.PETCAREXX */ .Xs.PETCAREXX, "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/heroImages/pet-care-hero-collage.png"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.HOUSEKEEP */ .Xs.HOUSEKEEP, "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/heroImages/housekeeping-hero-collage.png"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.SENIRCARE */ .Xs.SENIRCARE, "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/heroImages/senior-care-hero-collage.png"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.TUTORINGX */ .Xs.TUTORINGX, "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/heroImages/tutoring-hero-collage.png"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_0__/* .ServiceId.SPCLNEEDS */ .Xs.SPCLNEEDS, "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/optimized/heroImages/special-needs-collage.png"), _obj));
    var specialtyHeroImageMap = Object.freeze({
        "/adult-care": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/heroImages/adult-care-hero-collage.png",
        "/senior-living": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/heroImages/senior-living-hero-collage.png",
        "/bird-sitters": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/optimized/heroImages/bird-sitters-collage.png",
        "/cat-sitters": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/optimized/heroImages/cat-sitters-collage.png",
        "/day-care": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/optimized/heroImages/daycares-collage.png",
        "/newborn-nannies": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/optimized/heroImages/newborn-nannies-collage.png",
        "/post-surgery-care": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/optimized/heroImages/post-surgery-care-collage.png",
        "/senior-transportation": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/optimized/heroImages/senior-transportation-collage.png",
        "/special-needs-adult-care": "https://www.care.com/s/cms/web/visitor/greaterCareRebrand/searchDirectory/optimized/heroImages/special-needs-adult-care-collage.png"
    });
    var _segment;
    var heroImage = (_segment = specialtyHeroImageMap[segment]) !== null && _segment !== void 0 ? _segment : heroImageVerticalMap[serviceId];
    return heroImage ? (0,_helpers_generateURLWithParams__WEBPACK_IMPORTED_MODULE_2__/* .generateUrlWithParams */ .H)(heroImage, imQueryParams) : null;
};


/***/ }),

/***/ 28748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ useSearchResults; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/API/fragments/common.ts
var common = __webpack_require__(37349);
;// CONCATENATED MODULE: ./src/API/getSearchResults.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  query getSearchResults(\n    $seoSegmentId: ID!\n    $pageNumber: Int\n    $filters: SEOSegmentationFilterInput\n    $ipAddress: String!\n    $userGeoInfo: String!\n    $botInfo: String!\n    $userAgent: String!\n    $hasFilters: Boolean!\n    $numberOfReviewsPerProfile: Int\n  ) {\n    seoSegmentationSearchResults(\n      filters: $filters\n      pageNumber: $pageNumber\n      testCell: null\n      seoSegmentId: $seoSegmentId\n      ipAddress: $ipAddress\n      botInfo: $botInfo\n      userGeoInfo: $userGeoInfo\n      userAgent: $userAgent\n      numberOfReviewsPerProfile: $numberOfReviewsPerProfile\n    ) {\n      ... on SEOSegmentationSearchResultsSuccess {\n        ...CaregiverSearchResultFields\n        ...ProviderSearchResultFields\n        ...JobSearchResultFields\n        ...ArchivedJobSearchResultFields\n\n        filters @include(if: $hasFilters) {\n          location {\n            zipcode\n            city\n            state\n          }\n        }\n      }\n      ... on SEOSegmentationSearchResultsError {\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n    seoSegmentationDetails(seoSegmentId: $seoSegmentId) {\n      __typename\n      ... on SEOSegmentationDetailsSuccess {\n        segmentationDetails {\n          searchResultsHeader\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GET_SEARCH_RESULTS = (0,lib/* default */.ZP)(_templateObject(), common/* CAREGIVER_SEARCH_RESULT_FIELDS */.ut, common/* PROVIDER_SEARCH_RESULT_FIELDS */.GF, common/* JOB_SEARCH_RESULT_FIELDS */.OS, common/* ARCHIVED_JOB_SEARCH_RESULT_FIELDS */.d7);
/* harmony default export */ var API_getSearchResults = (GET_SEARCH_RESULTS);

// EXTERNAL MODULE: ./src/utils/filtersStorage.ts
var filtersStorage = __webpack_require__(85627);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/searchResultsReducer.ts


// Create the reducer function
var searchReducer = function(state, action) {
    switch(action.type){
        case "SET_FILTERS":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                filters: action.payload
            });
        case "SET_PAGE_NUMBER":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                pageNumber: action.payload
            });
        case "UPDATE_ALL_RESULTS":
            var _filters, _caregiverSearchResults, _providerSearchResults, _jobSearchResults, _archivedJobSearchResults;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                filters: (_filters = action.payload.filters) !== null && _filters !== void 0 ? _filters : state.filters,
                pagination: action.payload.pagination,
                caregiverSearchResults: (_caregiverSearchResults = action.payload.caregiverSearchResults) !== null && _caregiverSearchResults !== void 0 ? _caregiverSearchResults : state.caregiverSearchResults,
                providerSearchResults: (_providerSearchResults = action.payload.providerSearchResults) !== null && _providerSearchResults !== void 0 ? _providerSearchResults : state.providerSearchResults,
                jobSearchResults: (_jobSearchResults = action.payload.jobSearchResults) !== null && _jobSearchResults !== void 0 ? _jobSearchResults : state.jobSearchResults,
                archivedJobSearchResults: (_archivedJobSearchResults = action.payload.archivedJobSearchResults) !== null && _archivedJobSearchResults !== void 0 ? _archivedJobSearchResults : state.archivedJobSearchResults
            });
        default:
            return state;
    }
};

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/useSearchResults.ts







var useSearchResults = function(param) {
    var initialFilters = param.initialFilters, initialPagination = param.initialPagination, seoSegmentId = param.seoSegmentId, isNationalPage = param.isNationalPage, showUserFilters = param.showUserFilters, _initialSearchResults = param.initialSearchResults, initialSearchResults = _initialSearchResults === void 0 ? {} : _initialSearchResults;
    var router = (0,next_router.useRouter)();
    var _caregiverSearchResults, _providerSearchResults, _jobSearchResults, _archivedJobSearchResults;
    // Initialize state with useReducer using our factory function
    var ref = (0,react.useReducer)(searchReducer, {
        filters: initialFilters,
        pagination: initialPagination,
        caregiverSearchResults: (_caregiverSearchResults = initialSearchResults.caregiverSearchResults) !== null && _caregiverSearchResults !== void 0 ? _caregiverSearchResults : [],
        providerSearchResults: (_providerSearchResults = initialSearchResults.providerSearchResults) !== null && _providerSearchResults !== void 0 ? _providerSearchResults : [],
        jobSearchResults: (_jobSearchResults = initialSearchResults.jobSearchResults) !== null && _jobSearchResults !== void 0 ? _jobSearchResults : [],
        archivedJobSearchResults: (_archivedJobSearchResults = initialSearchResults.archivedJobSearchResults) !== null && _archivedJobSearchResults !== void 0 ? _archivedJobSearchResults : [],
        pageNumber: 1
    }), state = ref[0], dispatch = ref[1];
    // Extract state properties for easier access
    var filters = state.filters, pagination = state.pagination, caregiverSearchResults = state.caregiverSearchResults, providerSearchResults = state.providerSearchResults, jobSearchResults = state.jobSearchResults, archivedJobSearchResults = state.archivedJobSearchResults, pageNumber = state.pageNumber;
    // Helper function to create query variables
    var getQueryVariables = (0,react.useCallback)(function(filterValues) {
        var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : pageNumber;
        return {
            filters: filterValues,
            pageNumber: page,
            seoSegmentId: seoSegmentId,
            ipAddress: "",
            botInfo: "",
            userGeoInfo: "",
            userAgent: "",
            hasFilters: isNationalPage || showUserFilters
        };
    }, [
        pageNumber,
        seoSegmentId,
        isNationalPage,
        showUserFilters
    ]);
    // Initialize the GraphQL query hook
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(API_getSearchResults, {
        variables: getQueryVariables((0,filtersStorage/* loadFilters */.dm)()),
        onCompleted: function(data) {
            var searchResultData = data.seoSegmentationSearchResults.__typename === "SEOSegmentationSearchResultsSuccess" ? data.seoSegmentationSearchResults : null;
            if (searchResultData) {
                dispatch({
                    type: "UPDATE_ALL_RESULTS",
                    payload: {
                        filters: searchResultData.filters,
                        pagination: searchResultData.pagination,
                        caregiverSearchResults: searchResultData.caregiverSearchResults,
                        providerSearchResults: searchResultData.providerSearchResults,
                        jobSearchResults: searchResultData.jobSearchResults,
                        archivedJobSearchResults: searchResultData.archivedJobSearchResults
                    }
                });
            }
        }
    }), 2), getSearchResults = ref1[0], ref2 = ref1[1], isLoading = ref2.loading, isClientSearchResultsQuery = ref2.called;
    // Handle smooth scrolling to an element
    var scrollToElement = (0,react.useCallback)(function(scrollRef) {
        if (scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) {
            scrollRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, []);
    // Handle page clicks
    var handlePageClick = (0,react.useCallback)(function(newPage, scrollRef) {
        var filterSelected = (0,filtersStorage/* loadFilters */.dm)() || {};
        if (filters === null || filters === void 0 ? void 0 : filters.location) {
            filterSelected.zipcode = filters.location.zipcode;
        }
        scrollToElement(scrollRef);
        dispatch({
            type: "SET_PAGE_NUMBER",
            payload: newPage
        });
        getSearchResults({
            variables: getQueryVariables(filterSelected, newPage)
        });
    }, [
        filters,
        getQueryVariables,
        getSearchResults,
        scrollToElement
    ]);
    // Handle fetching results with filters
    var fetchResults = (0,react.useCallback)(function(filterVals, resetPage, scrollRef) {
        scrollToElement(scrollRef);
        var newPage = resetPage ? 1 : pageNumber;
        getSearchResults({
            variables: getQueryVariables(filterVals, newPage)
        });
        if (resetPage) {
            dispatch({
                type: "SET_PAGE_NUMBER",
                payload: 1
            });
            router.push(seoSegmentId, undefined, {
                shallow: true
            });
        }
    }, [
        getQueryVariables,
        getSearchResults,
        pageNumber,
        router,
        scrollToElement,
        seoSegmentId
    ]);
    // Create a memoized setFilters function that uses dispatch
    var setFilters = (0,react.useCallback)(function(newFilters) {
        dispatch({
            type: "SET_FILTERS",
            payload: newFilters
        });
    }, []);
    return {
        filters: filters,
        setFilters: setFilters,
        pagination: pagination,
        caregiverSearchResults: caregiverSearchResults,
        providerSearchResults: providerSearchResults,
        jobSearchResults: jobSearchResults,
        archivedJobSearchResults: archivedJobSearchResults,
        pageNumber: pageNumber,
        isLoading: isLoading,
        isClientSearchResultsQuery: isClientSearchResultsQuery,
        handlePageClick: handlePageClick,
        fetchResults: fetchResults
    };
};


/***/ }),

/***/ 32826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useSearchDirectoryData; },
/* harmony export */   "z": function() { return /* binding */ SearchDirectoryDataProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var SearchDirectoryDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var SearchDirectoryDataProvider = function(param) {
    var children = param.children, pageData = param.pageData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchDirectoryDataContext.Provider, {
        value: pageData,
        children: children
    });
};
var useSearchDirectoryData = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SearchDirectoryDataContext);
    if (!context) {
        throw new Error("useSearchDirectoryData must be used within a SearchDirectoryDataProvider");
    }
    return context;
};


/***/ }),

/***/ 8018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ generateUrlWithParams; }
/* harmony export */ });
/**
 * Generate a new URL with the given base URL and parameters
 * @param baseUrl - The base URL
 * @param params - The parameters to append to the URL
 * @returns The generated URL
 * @example
 * ```ts
 * const baseUrl = 'https://example.com/image.jpg';
 * const params = { width: '100', height: '100' };
 * const url = generateURLWithParams(baseUrl, params);
 * console.log(url); // 'https://example.com/image.jpg?width=100&height=100'
 * ```
 *  */ var generateUrlWithParams = function(baseUrl, params) {
    var url = new URL(baseUrl);
    Object.keys(params).forEach(function(key) {
        url.searchParams.append(key, params[key]);
    });
    return url.toString();
};


/***/ }),

/***/ 80427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getDefaultHeroImageLarge; }
/* harmony export */ });
/* harmony import */ var _utils_createRelativeImageURL__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83174);

/**
 * This function returns the default large hero image from the SEO Segmentation Hero Image.
 * If the hero image is not available, it returns null.
 * @param {seoSegmentationListingPage['seoSegmentationHeroImage']} seoSegmentationHeroImage
 * @returns {string | null} - The default hero image URL or null if not available.
 */ var getDefaultHeroImageLarge = function(seoSegmentationHeroImage) {
    if (seoSegmentationHeroImage.__typename === "SEOSegmentationHeroImageSuccess" && seoSegmentationHeroImage.heroImage) {
        return (0,_utils_createRelativeImageURL__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(seoSegmentationHeroImage.heroImage.largeImageURL);
    }
    return null;
};


/***/ }),

/***/ 12806:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function columnarLinkedList(linkList) {
    var numOfColumns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (numOfColumns < 1) throw new Error("Number of columns must be greater than 0!");
    return linkList.reduce(function(resultArray, item, index) {
        var chunkIndex = Math.floor(index / numOfColumns);
        var resultArrayCopy = resultArray;
        if (!resultArrayCopy[chunkIndex]) {
            resultArrayCopy[chunkIndex] = new Array(); // start a new chunk
        }
        resultArrayCopy[chunkIndex].push(item);
        return resultArrayCopy;
    }, []);
}
/* harmony default export */ __webpack_exports__["Z"] = (columnarLinkedList);


/***/ }),

/***/ 85627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HJ": function() { return /* binding */ saveFilters; },
/* harmony export */   "K5": function() { return /* binding */ clearFilters; },
/* harmony export */   "dm": function() { return /* binding */ loadFilters; },
/* harmony export */   "ku": function() { return /* binding */ removeFilter; }
/* harmony export */ });
/* unused harmony export updateFilterField */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);


var loadFilters = function() {
    try {
        var serializedState = localStorage.getItem("filters");
        if (serializedState === null) {
            return null;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return null;
    }
};
var saveFilters = function(filter, __callback) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        filterObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, filterObj, filter);
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
        if (__callback) {
            __callback();
        }
    } catch (err) {
    // return undefined;
    }
};
var updateFilterField = function(filterName, filterValue) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        set(filterObj, filterName, filterValue);
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
    } catch (err) {
    // return undefined;
    }
};
var clearFilters = function() {
    try {
        localStorage.removeItem("filters");
    } catch (err) {
    // return undefined;
    }
};
var removeFilter = function(key) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        delete filterObj[key];
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
    } catch (err) {
    // return undefined;
    }
};


/***/ }),

/***/ 7360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getZipcodeFromGeoInfo; }
/* harmony export */ });
var getZipcodeFromGeoInfo = function(userGeoInfo) {
    var match = userGeoInfo === null || userGeoInfo === void 0 ? void 0 : userGeoInfo.match(/zip=(\d{5})/);
    if (match && match[1]) {
        return match[1];
    }
    return "";
};


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

}]);